import { useEffect, useState } from 'react';
import type { LatLng } from '@/shared/types/coords.schema';

const useLocation = (
	onError?: PositionErrorCallback,
	option?: PositionOptions,
) => {
	const [location, setLocation] = useState<LatLng | null>(null);
	const [isLocationPermissionDenied, setIsLocationPermissionDenied] =
		useState<boolean>(false);

	useEffect(() => {
		if (!('geolocation' in navigator)) return;

		const watchId = navigator.geolocation.watchPosition(
			(position) => {
				setIsLocationPermissionDenied(false);
				setLocation({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				});
			},
			(error) => {
				if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
					setIsLocationPermissionDenied(true);
				}
				onError?.(error);
			},
			option,
		);

		return () => navigator.geolocation.clearWatch(watchId);
	}, [onError, option]);

	return { location, isLocationPermissionDenied };
};

export default useLocation;
